import LogisticsCompany from "@/enum/LogisticsCompany";
import { get, post } from "@/services/http/platformServer";

export interface ImportShippingParams {
    /** excel文件，文件模板格式应为xls或xlsx，模板第一列为订单号，第二列为快递公司名称，第三列为运单号 */
    excelFile: File;

    /** 不传代表选择'全部快递' */
    logisticsCompany?: LogisticsCompany;

    enableReship: boolean;

    /**店铺id */
    shopId: number;

    enableShipment: boolean;
}

export interface ImportShippingResult {
    logisticsCompany: LogisticsCompany;
    message: string;
    orderOriginalId: string;
    successful: boolean;
    waybillNo: string;
    index: number;
}

export interface ImportShipTask {
    id: number;
    isDone: boolean;
    results: ImportShippingResult[];
}

/**
 * 导入运单号发货
 */
export function submitImportShippingTask(params: ImportShippingParams): Promise<ImportShipTask> {
    const data = new FormData();
    data.append("excelFile", params.excelFile);

    if (params.logisticsCompany) {
        data.append("logisticsCompany", params.logisticsCompany);
    }

    data.append("enableReship", params.enableReship?.toString());

    data.append("shopId", params.shopId?.toString());

    data.append("enableShipment", params.enableShipment?.toString());

    return post(params.shopId, "/import_shipping/submit_task", data, { timeout: 60000 });
}

export interface QnImportShipParams {
    shopId: number;
    enableReship: boolean;
    logisticsCompany?: LogisticsCompany;

    excelFileOriginalName: string;
    excelFileSize: number;
    excelFileUrl: string;
    enableShipment: boolean;
}

/**
 * 导入运单号发货 （千牛专用）
 */
export function qnSubmitImportShippingTask(params: QnImportShipParams): Promise<ImportShipTask> {
    return post(params.shopId, "/import_shipping/qianniu/submit_task", params);
}

/**查询 */
export function getImportShippingTask(shopId: number, taskId: number): Promise<ImportShipTask> {
    return get(shopId, "/import_shipping/task", {
        taskId,
    });
}
